import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import { Repo } from './Call.d'

const ROOT_URL = '/entity/calls'

export const CallRepository = {
  Search: async (params: Repo.Call.Search.Params) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<Repo.Call.Search.Response>(url)
  },

  FindById: async ({ callId }: Repo.Call.FindById.Params) => {
    const url = ROOT_URL + `/${callId}`
    return await WitaConnector.get<Repo.Call.FindById.Response>(url)
  },

  Create: async (params: Repo.Call.Create.Params) => {
    const formData = new FormData()
    formData.append('assetId', params.assetId)
    formData.append('description', params.description)
    formData.append('requesterName', params.requesterName)
    formData.append('requesterPhone', params.requesterPhone)
    formData.append('requesterMail', params.requesterMail)
    params.files.map((ea) => formData.append('files', ea[0]))

    const url = ROOT_URL
    return await WitaConnector.post<Repo.Call.Create.Response>(url, formData)
  },

  TechAssign: async ({ id, ...params }: Repo.Call.TechAssign.Params) => {
    const url = ROOT_URL + `/${id}/tech-assign`
    return await WitaConnector.put<Repo.Call.TechAssign.Response>(url, params)
  },

  End: async ({ id, ...params }: Repo.Call.End.Params) => {
    const url = ROOT_URL + `/${id}/end`
    return await WitaConnector.put<Repo.Call.End.Response>(url, params)
  },

  Cancel: async ({ id, ...params }: Repo.Call.Cancel.Params) => {
    const url = ROOT_URL + `/${id}/cancel`
    return await WitaConnector.put<Repo.Call.Cancel.Response>(url, params)
  },
}
